import { ModalContentContext } from "@/contexts/modal-context";
import { useContext, useRef } from "react";

const Modal = ({ backdrop }: { backdrop: boolean }) => {
  const ref = useRef(null);
  const { isOpen, closeModal, content } = useContext(ModalContentContext);
  return isOpen ? (
    <>
      {backdrop && (
        <div className="fixed top-0 left-0 h-full w-full bg-black opacity-70" />
      )}
      <div
        className="bg-card fixed top-[15%] left-1/2 z-50 w-full max-w-xl -translate-x-1/2 rounded pt-12 pb-5"
        ref={ref}
      >
        <button
          className="absolute top-1.5 right-3 bg-transparent text-2xl"
          onClick={closeModal}
        >
          &times;
        </button>
        {content}
      </div>
    </>
  ) : null;
};

export default Modal;
